import { optionsLOmode, optionsSecondaryMode } from "./options";

export const getMenuOptions = (tabId, isSecondary, disablePricingPage) => {
  return !isSecondary
    ? optionsLOmode(tabId)
    : optionsSecondaryMode(disablePricingPage);
};
